export const updateCourseDetail = "Update CourseDetail Mutation";
